<ng-template
  let-extraClass="extraClass"
  #topNav />

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="field-top-padding field-bottom-padding">
          <tidy-input
            [label]="'First name *'"
            formControlName="firstName"
            [form]="form.controls.firstName"
            [icon]="'assets/svg/person-circle.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter employee\'s first name'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Last name *'"
            formControlName="lastName"
            [form]="form.controls.lastName"
            [icon]="'assets/svg/person-circle.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter employee\'s last name'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            [label]="'Email *'"
            formControlName="email"
            type="email"
            [form]="form.controls.email"
            [icon]="'assets/svg/mail.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email'" />
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-button
      [text]="'Save'"
      [action]="boundSaveChanges"
      class="primary" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

  </tidy-wrapper>
</ng-template>

<ion-content class="ion-content-right-column">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>
